import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'
import DashboardWrapper from '../Dashboard/components/DashboardWrapper'
import InnerBanner from '../../components/InnerBanner'
import { PRIVATE_ROUTES } from '../../Routes/routes'
import { getCompanyInformation } from '../../services/CompanyData'
import { TAGS } from '../../services/Tags'
import BillingCalculator from './components/BillingCalculator'
import ContractPreviewSection from '../../components/ContractPreviewSection/ContractPreviewSection'

const Accounting = () => {
  const { companyId } = useParams()
  const [calcResult, setCalcResult] = useState(null)

  const { data: company } = useQuery({
    queryKey: [TAGS.company_detail, companyId],
    queryFn:  () => getCompanyInformation(companyId),
    enabled:  !!companyId,
  })

  return (
    <DashboardWrapper>
      <div className="p-3 p-lg-4" style={{ maxWidth: '1100px', margin: '0 auto' }}>

        <InnerBanner
          before="Inicio"
          beforeRoute={PRIVATE_ROUTES.dashboard}
          text="Contabilidad"
          className="mb-3"
        />

        <h2 className="text-bg-brand mb-4" style={{ fontWeight: 800, fontSize: '22px' }}>
          Calculadora de facturación
        </h2>

        <div className="bg-white rounded border p-4" style={{ borderColor: '#e5e7eb' }}>
          <p className="mb-4" style={{ fontSize: '13px', color: '#6b7280' }}>
            Calcula el cobro del primer mes en función del tag, la fecha de inicio y el impuesto.
          </p>

          <BillingCalculator
            companyId={company?.id}
            createdAt={company?.created_at}
            onChange={setCalcResult}
          />

          {calcResult && (
            <div
              className="mt-4 p-3 rounded d-flex flex-wrap gap-3 align-items-center justify-content-between"
              style={{ background: '#f5f3ff', border: '1px solid #ddd6fe' }}
            >
              <div style={{ fontSize: '13px', color: '#5b21b6' }}>
                <strong>Resumen listo para guardar:</strong>{' '}
                {calcResult.tag} ·{' '}
                Inicio {dayjs(calcResult.startDate).format('DD/MM/YYYY')} ·{' '}
                {calcResult.taxApplies ? `IVA ${calcResult.taxPercent}%` : 'No sujeto'}
              </div>
              <button
                type="button"
                className="btn btn-sm btn-bg-CTA-primary px-4"
                onClick={() => {
                  // TODO: conectar con endpoint de guardado
                  console.log('Guardar configuración:', calcResult)
                }}
              >
                Guardar configuración
              </button>
            </div>
          )}
        </div>

        <ContractPreviewSection fetchContracts />

      </div>
    </DashboardWrapper>
  )
}

export default Accounting
